/**
 * Palmo Custom Error Class
 */
class PalmoError extends Error {
    constructor(code, message, originalError = null, status = null) {
        super(message);
        this.name = 'PalmoError';
        this.code = code;
        this.originalError = originalError;
        this.status = status;
        this.statusCode = status;
    }

    toJSON() {
        const obj = {
            name: this.name,
            code: this.code,
            message: this.message,
            details: this.originalError ? this.originalError.message : null
        };
        if (this.status !== null && this.status !== undefined) {
            obj.status = this.status;
        }
        return obj;
    }
}

module.exports = PalmoError;
